import SVG from '../two/image.svg';

export default {
  SVG,
  name: 'E*',
};
